import { createFileRoute } from '@tanstack/react-router'
import {
  AuthGuard,
  useCurrentOrganizationId,
  useMyConvexOrganizationId,
  usePermissions,
} from '@/features/auth'
import {
  DeleteOrganizationButton,
  PeriodConfigForm,
  TransferOwnershipButton,
} from '@/features/organization/components'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/(dashboard)/organization/settings/')({
  component: RouteComponent,
  beforeLoad: () => ({
    title: 'Organization Settings',
    breadcrumbs: [{ title: 'Organization' }, { title: 'Settings' }],
  }),
})

function RouteComponent() {
  const orgId = useCurrentOrganizationId() || ''
  const convexOrgId = useMyConvexOrganizationId()
  const { hasOrganizationRole } = usePermissions()
  const isAdmin = hasOrganizationRole(orgId, 'admin')
  const isPlatformOrg = useAuthStore(
    (s) => s.currentOrganization?.isAdmin ?? false,
  )

  return (
    <AuthGuard
      requiredOrganizationRole={{
        organizationId: orgId,
        role: 'admin',
      }}
    >
      <div className="space-y-6">
        <div className="p-6 bg-muted/30 rounded-lg">
          <h1 className="text-2xl font-semibold text-foreground">
            Organization Settings
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Administrative settings for your organization.
          </p>
        </div>

        <PeriodConfigForm organizationId={convexOrgId} />

        {isAdmin ? (
          <>
            <div className="p-6 rounded-lg bg-warning/10 border border-warning/30 flex items-center justify-between gap-6">
              <div>
                <h2 className="text-lg font-semibold text-foreground">
                  Transfer ownership
                </h2>
                <p className="text-sm text-muted-foreground mt-2">
                  Transfer this organization to another active member. They will
                  become the new owner and be granted admin access.
                </p>
              </div>
              <TransferOwnershipButton />
            </div>

            {!isPlatformOrg ? (
              <div className="p-6 rounded-lg bg-destructive/10 border border-destructive/30 flex items-center justify-between gap-6">
                <div>
                  <h2 className="text-lg font-semibold text-foreground">
                    Danger zone
                  </h2>
                  <p className="text-sm text-muted-foreground mt-2">
                    Deleting your organization will permanently remove all data
                    from the authentication provider and this application. This
                    action is irreversible.
                  </p>
                </div>
                <DeleteOrganizationButton />
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </AuthGuard>
  )
}
